import type { ReactNode } from 'react'

interface CardProps {
  title?: ReactNode
  actions?: ReactNode
  children: ReactNode
  className?: string
  bodyClassName?: string
}

export function Card({ title, actions, children, className = '', bodyClassName = '' }: CardProps) {
  return (
    <div className={`card custom-card ${className}`.trim()}>
      {(title || actions) && (
        <div className="card-header justify-content-between">
          {title && <div className="card-title">{title}</div>}
          {actions && <div className="d-flex gap-2">{actions}</div>}
        </div>
      )}
      <div className={`card-body ${bodyClassName}`.trim()}>{children}</div>
    </div>
  )
}
